<div class="margin-auto circle-mean border-radius-50 light-background" (click)="openFile()">
  <div
    [ngStyle]="{
      'background-image': 'url(' + (photoUrl ? photoUrl : defaultPhoto) + ')'
    }"
    class="width-100 height-100 background border-radius-50"
  >
  </div>
  <div class="icon" text-end *ngIf="showIcon">
    <ion-icon color="white" [name]="iconName" *ngIf="iconName"></ion-icon>
    <ion-icon color="white" [src]="srcIcon" *ngIf="srcIcon"></ion-icon>
  </div>
</div>
<input
  type="file"
  id="fileInput"
  style="display:none;"
  [accept]="fileTypes"
  (change)="fileProgress($event)"
/>
